export const CardLayout = {
    List: 1,
    Grid: 2
};

export const CardIconType = {
    None: 0,
    Initials: 1,
    FontAwesomeIcon: 2,
    AppFontIcon: 3,
    Avatar: 4,
    Custom: 5
};

export const BadgeStyle = {
    None: 0,
    Primary: 1,
    Secondary: 2,
    Danger: 3,
    Default: 4
};

export const BadgeAlignment = {
    Left: 1,
    Right: 2
};
